import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconAsset from 'material-ui/svg-icons/editor/attach-file';
import AssetChip from './AssetChip';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};

const AssetSegment = ({assets}) => {

    if (!assets  || assets.length <= 0) { return false; } // guard

    return (
        <Card className="cent-card" key="assetSegment">
            <CardHeader
                title="Attachments"
                subtitle="additional files"
                avatar={<IconAsset {...iconProps}/>}
            />
            <CardText className="cent-card-text">
                {assets.map((asset) => (
                    <AssetChip
                        key={asset.id}
                        data={asset}
                    />
                ))}
            </CardText>
        </Card>
    );

};

AssetSegment.propTypes = {
    assets:   PropTypes.arrayOf(PropTypes.object),
};

export default AssetSegment;
